import { create } from "zustand";

/** Open/close state for the ⌘K command palette. Lives in a store so any
 *  surface (a toolbar button, a deep-link, a future hint) can summon it —
 *  the palette itself is mounted once in AppShell. Mirrors useTheme's shape. */
interface CommandBarState {
  open: boolean;
  /** Optional query to seed the input with when summoned (e.g. the ask-popover
   *  hands off "Explain this value …"). Consumed + cleared by CommandBar on open. */
  prefill: string | null;
  setOpen: (open: boolean) => void;
  toggle: () => void;
  /** Open the palette seeded with a query — the surface-to-⌘K escape hatch. */
  openWith: (query: string) => void;
  clearPrefill: () => void;
}

export const useCommandBar = create<CommandBarState>((set) => ({
  open: false,
  prefill: null,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
  openWith: (query) => set({ open: true, prefill: query }),
  clearPrefill: () => set({ prefill: null }),
}));
